export default __webpack_public_path__ + "static/logo-b5b32bc24f51ba30ad7729993146ac5f.svg";